
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Publicacion: Publicacion;

        public AgregarLink()
        {
            this.Controlador.EnviarARespuesta( this.Publicacion.Link );
        }

        public Abrir()
        {
            window.open( this.Publicacion.Link );
        }
    }
